MoyaComponents.register('extras.admin.boxItems', (el) => {
	$.localise('ui-multiselect', {language: moya.lang, path: '/_moya/js/jquery/multiselect/js/locale/'});
	const moyaFetch = MoyaContainer.get('core.fetch');
	const categoryElement = el.querySelector('#categoryId');
	const source = el.querySelector('#source');
	const itemsElement = el.querySelector('#items');
	const itemsLabel = el.querySelector('label[for=items]');
	categoryElement.addEventListener('change', (e) => {
		updateItems(e);
		updateUseReadmore(e);
	});
	if (source) {
		source.addEventListener('change', (e) => {
			el.dataset.source = e.target.value;
			updateItems(e);
		});
	}

	const refreshMultiselect = () => {
		if (itemsElement.style.display === 'none') {
			$(itemsElement).multiselect('destroy');
		}
		if (el.dataset.source === 'custom') {
			itemsElement.setAttribute('multiple', 'multiple');
			itemsLabel.innerText = itemsElement.dataset.labelCustom;
			$(itemsElement).multiselect({
				sortable: true,
				searchable: true,
			});
		}
		else if (el.dataset.source === 'single') {
			itemsElement.removeAttribute('multiple');
			itemsLabel.innerText = itemsElement.dataset.labelSingle;
		}
	};

	const updateSelectOptions = (options) => {
		itemsElement.innerHTML = '';

		for (const [id, label] of Object.entries(options)) {
			const option = document.createElement('option');
			option.value = id;
			option.innerText = label.toString();
			itemsElement.appendChild(option);
		}

		const changeEvent = new Event('change', {bubbles: true});
		itemsElement.dispatchEvent(changeEvent);
		MoyaComponents.run(itemsElement);
	};


	const updateItems = (e = null) => {
		const categoryId = parseInt(categoryElement.value);
		if (!itemsElement) {
			return;
		}
		if (!categoryId || source.value === 'all') {
			updateSelectOptions([]);
			refreshMultiselect();
			return;
		}

		if (e && e.type === 'change') {
			moyaFetch.fetchJson(`/_/${moya.division}/extras/box/categoryItems/${categoryId}`).then(response => {
				updateSelectOptions(response);
				refreshMultiselect();
			});
		}
		else {
			refreshMultiselect();
		}
	};

	const updateUseReadmore = (e) => {
		const categoryId = parseInt(categoryElement.value);
		el.dataset.useReadmore = el.dataset.inSitemap.split(',').includes(categoryId.toString())
			? '1'
			: '0';
	};

	updateItems();
});
